/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/schedule" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdSchedule } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdSchedule = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdSchedule,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult> => {
    return fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/timing/schedule`, "GET", {}, { signal });
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdScheduleResult
);
